var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { CONFIG } from "@/config";
import { atom } from "jotai";
import { useAtomValue } from "jotai";
import { useLayoutEffect, useMemo, useState } from "react";
import { loadTexture, PriorityLoader, } from "../loader/PriorityLoader";
export var requirePage = CONFIG.textures.folder;
var ArtbookPages = /** @class */ (function () {
    function ArtbookPages(pages) {
        this.pages = pages;
    }
    ArtbookPages.prototype.getPageCount = function () {
        return this.pages.length;
    };
    ArtbookPages.prototype.getSheetCount = function () {
        return Math.ceil(this.pages.length / 2);
    };
    ArtbookPages.prototype.get = function (page) {
        if (page < 0 || page >= this.pages.length) {
            return [];
        }
        var pageData = requirePage(this.pages[page]);
        return pageData.images.slice(1).map(function (i) { return i.path; });
    };
    ArtbookPages.prototype.getThumbnail = function (page) {
        if (page < 0 || page >= this.pages.length) {
            throw new Error("No page ".concat(page));
        }
        var pageData = requirePage(this.pages[page]);
        return pageData.images[0].path;
    };
    return ArtbookPages;
}());
export { ArtbookPages };
var PriorityLoaderAtom = atom(function () { return new PriorityLoader(4); });
export function useMultiResTextureLoader(cancellationToken, files, load) {
    var priorityLoader = useAtomValue(PriorityLoaderAtom);
    var promises = useMemo(function () {
        return files.map(function (file, index) {
            return function () {
                return priorityLoader.queuePromise(function () {
                    return loadTexture(file, cancellationToken);
                }, index);
            };
        });
    }, [cancellationToken, files, priorityLoader]);
    var state = useSequentialLoad(promises, load);
    var loadedTextures = state
        .filter(function (e) { return e.type === "result"; })
        .map(function (e) { return e.result; });
    var finalTexture = loadedTextures.length > 0
        ? loadedTextures[loadedTextures.length - 1]
        : null;
    useLayoutEffect(function () {
        if (finalTexture != null) {
            finalTexture.flipY = false;
            finalTexture.needsUpdate = true;
        }
    }, [finalTexture]);
    return finalTexture;
}
function useSequentialLoad(promises, load) {
    var _a = __read(useState([]), 2), results = _a[0], setResults = _a[1];
    useLayoutEffect(function () {
        setResults([]);
    }, [promises]);
    useLayoutEffect(function () {
        if (results.length < promises.length && results.length < load) {
            var promise = promises[results.length]();
            promise.then(function (res) {
                setResults(__spreadArray(__spreadArray([], __read(results), false), [{ type: "result", result: res }], false));
            }, function (err) {
                setResults(__spreadArray(__spreadArray([], __read(results), false), [{ type: "error", error: err }], false));
            });
        }
    }, [promises, results, load]);
    return results;
}
